import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=196d9595&"
import script from "./CategoryModal.vue?vue&type=script&lang=js&"
export * from "./CategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports